import React from 'react';
import formatDate from 'date-fns/format';
import {View, Text, Platform} from 'react-native';
import {images} from '../../../../../assets/icons';
import {TransactionItem} from '../../../../../shared/models/api/eCertificatesResponsePayload';
import {numberFormatToRub} from '../../../../../shared/utils/numberFormatToRub';
import {isAmountChangeNegative} from '../../../helpers';
import {useTruItemStyles} from './TruItem.style';
import {useTheme} from '../../../../../shared/theme';

interface TruItemProps extends Omit<TransactionItem, 'number'> {
  showBorder?: boolean;
}

export function TruItem({
  truName,
  typeName,
  amount,
  quantity,
  sellerDepartment,
  dateTime,
  showBorder = true,
}: TruItemProps) {
  const styles = useTruItemStyles();
  const theme = useTheme();

  return (
    <View style={styles.truItem}>
      <View style={showBorder ? styles.innerContainer : undefined}>
        <View style={[styles.row, {marginBottom: 16}]}>
          <View style={styles.icon}>
            <images.Basket
              width={24}
              height={24}
              color={theme.color.primaryColor}
              strokeWidth={Platform.OS !== 'web' ? 0.1 : 1}
            />
          </View>

          <Text style={styles.truName}>{truName}</Text>
        </View>

        <View style={[styles.row, {marginBottom: 8}]}>
          <Text style={styles.label}>Кол-во (шт)</Text>
          <Text style={styles.text}>{quantity}</Text>
        </View>

        <View style={[styles.row, {marginBottom: 8}]}>
          <Text style={styles.label}>
            Стоимость,{' '}
            <Text
              style={{
                fontFamily: Platform.select({
                  web: 'system-ui',
                  ios: 'System',
                  android: 'sans-serif',
                  default: undefined,
                }),
              }}>
              ₽
            </Text>
          </Text>
          <Text style={styles.text}>
            {isAmountChangeNegative(typeName) ? '-' : '+'}
            {numberFormatToRub(amount)}
          </Text>
        </View>

        <View style={[styles.row, {marginBottom: 8}]}>
          <Text style={styles.label}>Дата</Text>
          <Text style={styles.text}>{formatDate(new Date(dateTime), 'dd.MM.yyyy')}</Text>
        </View>

        <View style={[styles.row, {marginBottom: 8}]}>
          <Text style={styles.label}>Продавец</Text>
          <Text style={styles.text}>{sellerDepartment}</Text>
        </View>
      </View>
    </View>
  );
}
